import axios from 'axios'
import config from './config'

let baseURL = config.baseURL
let baseContext = config.baseContext
let accessKeyID = config.accessKeyID
let accessKey = config.accessKey
let cloudBaseURL = config.cloudBaseURL
let _headers = {
  'appType': '4'
}
//let loginUrl =  config.loginUrl
const API = {
  getBaseContext () {
    return baseContext
  },
  getAccessInfo () {
    return {
      accessKey: accessKey,
      accessKeyID: accessKeyID
    }
  },
  getBaseUrRl () {
    return baseURL
  },
  getGameList () {
    let url = baseURL + '/game/webClientGame/queryH5RecommGameInfos'
    return axios.get(url, { headers: _headers })
  },
  queryWapAdvertInfos () {
    let url = baseURL + '/game/wapClientArticle/queryWapAdvertInfos'
    return axios.post(url, {'advertTerminal' : '2' }, { headers: _headers })
  },
  getSubjectList () {
    let url = baseURL + '/game/Publish/queryPublishSubjectList'
    return axios.post(url, { type: 1 }, { headers: _headers })
  },
  getLightNewsList (param) {
    let url = baseURL + '/game/wapClientArticle/queryLightArticles'
    return axios.post(url, param, { headers: Object.assign(param.header, _headers) })
    //return axios.post(url, param,{headers: {'userId': '', 'platform' : '2','deviceId':'2','appChannel':'5','page':'1','pageSize':'10'}})
  },
  getVerifyCode (param) {
    let url = baseURL + '/user/smsService/sendVefifyCode'
    return axios.post(url, param, { headers: Object.assign(param.header, _headers) })
  },
  checkThirtyMemberCode(param) {
    let url = baseURL + '/member/memberights/checkThirtyMemberCode'
    return axios.post(url, param, { headers: Object.assign(param.header, _headers) })
  },
  getSubjectDetail (param) {
    let url = baseURL + '/game/Publish/queryPublishSubjectDetil'
    return axios.post(url, param.data, { headers: _headers })
  },
  // 热词接口
  getHotWords () {
    let url = baseURL + '/user/topSearch/v8.2.0/queryTopWords'
    return axios.get(url, { headers: _headers })
  },
  getGameDetail (param) {
    let url = baseURL + '/game/marketingClient/getGameDetail'
    return axios.post(url, param.data, { headers: _headers })
  },
  getInfoDetail (param) {
    let url = baseURL + 'game/gameInfo/queryNews'
    return axios.post(url, param.data, { headers: _headers })
  },
  getQrDetail () {
    let url = baseURL + 'user/weChatQQ/queryWechatAndQQ'
    // return axios.post(url)
    return axios.post(url,{}, { headers: _headers })
  },
  getCToken (param) {
    let url = baseURL + 'game/cToken/getCToken';
    return axios.post(url, param.data, { headers: _headers })
  },
  getAppUrl (param,channel) {
    // 获取下载地址
    let url = baseURL +'/user/apkChannel/v1.2/getDownloadUrlBySymbol?pageSymbol='+channel
    return axios.post(url, param.data, { headers: _headers })
  },
  // 剩余时间
  getRemainTime (param){
    let url = baseURL + 'user/userTask/queryLeftTime'
    return axios.post(url, param.data, { headers: _headers })
  },
  //云游戏列表
  getCloudGameList () {
    let url = cloudBaseURL+'/game/cloudGame/queryX86GameList'
    return axios.post(url, {}, { headers: _headers })
  },
  
  //云游戏详情页
  getCloudGameDetail(param){
    let url = cloudBaseURL + '/game/cloudGame/queryGameDetail?id='+param.data.id+'&userId='+param.data.userId
    return axios.get(url, { headers: _headers })
  },
  // 通过userId查询
  getUserInfoByUserId(param){
    let url = baseURL + 'user/userService/getUserInfoByUserId'
    return axios.post(url, param.data, { headers: Object.assign(param.headers, _headers) })
  },
  // 专题详情页查询
  querySubjectDetail(param){
    let url = baseURL + 'game/fantasSubject/v9.2.0/querySubjectDetail'
    return axios.post(url, param.data, { headers: Object.assign(param.headers, _headers) })
  },
  
  // 登录权益
  // getLoginUrl () {
  //   console.log(loginUrl)
  //   return loginUrl
  // },
  postJinFenLogin (param) {
    let url = baseURL + '/user/userService/createUserLoginInfo'
    return axios.post(url, param.data, { headers: param.headers })
  },
  postJinFenEvent (param) {
    let url = baseURL + '/report/bilog/addClientEvent'
    return axios.post(url, param.data, { headers: param.headers })
  },
  postJinFenPlay (param) {
    let url = baseURL + '/report/report/reportUserBehavior'
    return axios.post(url, param.data, { headers: param.headers })
  },
  postJinFen (param) {
    let url = baseURL + '/user/userService/addClientEvent'
    return axios.post(url, param.data, { headers: Object.assign(param.headers, _headers) })
  },
  postLatencyFeedback(param) {
    let url = 'http://223.111.8.111:28080/user/userReport/saveReportInfo'
    return axios.post(url, param.data, { headers: Object.assign(param.headers, _headers) })
  },
  // 分享查询接口
  queryShareInfo(param) {
    let url = baseURL + '/user/shareInfo/queryShareInfo'
    return axios.post(url, param, { headers: _headers })
  },
   //获取奖品列表
   lotteryPageInfo (param) {
    let url = baseURL + '/member/lottery/v9.2.1/lotteryPageInfo'
    return axios.post(url, param, { headers: Object.assign(param.header, _headers) })
  },
  //抽奖
  drawLottery (param) {
    let url = baseURL + '/member/lottery/v9.2.1/drawLottery'
    return axios.post(url, param, { headers: Object.assign(param.header, _headers) })
  },
  //抽奖记录
  lotteryRecord(param) {
    let url = baseURL + '/member/lottery/v9.2.1/lotteryRecord'
    return axios.post(url, param, { headers: Object.assign(param.header, _headers) })
  }
}

export default API



// WEBPACK FOOTER //
// ./src/api/api.js